import * as React from "react"
import { graphql } from 'gatsby'
import Layout from "../layouts/layout"
import Explore from "../components/ExploreCategories";
import Image from "../components/image";
import HomeServices from "../partials/home/home-services";
import HomeHistory from "../partials/home/home-history";
// import HomeBlogs from "../partials/home/home-blogs";
import SignUpBanner from "../partials/common/cta-banner";
import HomeFeatured from "../partials/home/home-featured";
import ProductCarousel from "../partials/common/product-carousel";
import HomeSlider from "../partials/home/home-slider";
import Seo from 'gatsby-plugin-wpgraphql-seo';

const IndexPage = ({ data }) => {
  const page = data.wpPage.acfHomePage;
  const slides = page.homeSlider.slides;
  const bestSellers = data.shopifyCollection?.products;

  return (
    <Layout title={data.wpPage.title} >
      <Seo post={data.wpPage} />
      <h1 className="VisuallyHidden">{data.wpPage.title}</h1>

      <HomeSlider slides={slides} />
      <section className="Home__explore">
        <div className="Container">
          <h2 className="Title Title--lined">
            <span>Popular Categories</span>
          </h2>

          <Explore />
        </div>
      </section>

      <HomeFeatured />

      <section className="Home__benefits">
        <Image source={page.homeBenefits.background} imgClass="Home__benefits__bg" />
        <div className="Container">
          <div className="Home__benefits__wrap">
            {page.homeBenefits.benefits.map((item, index) => (
              <div className="Home__benefits__item" key={index}>
                <div className="Home__benefits__item--icon">
                  <Image
                    source={item.image}
                  />
                </div>
                <h4>{item.title}</h4>
                <p dangerouslySetInnerHTML={{__html: item.text}} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <ProductCarousel className="Home__Best__Sellers" products={bestSellers} title="Our Best Sellers" align="center" />

      <HomeServices content={page.homeServices} />

      <HomeHistory content={page.homeAbout} />

      {/* <HomeBlogs content={page.homeBlogs} /> */}

      <SignUpBanner />

    </Layout>
  )
}

export default IndexPage

export const homeQuery = graphql`
  query MyQuery {
    wpPage(isFrontPage: {eq: true}) {
      id
      title
      featuredImage {
        node {
          mediaDetails {
            file
          }
        }
      }
      acfHomePage {
        homeSlider {
          slides {
            text
            title
            hasProduct
            product {
              products {
                productCode
                topPosition
                leftPosition
              }
            }
            image {
              localFile {
                childCloudinaryAsset {
                  gatsbyImageData
                }
              }
            }
            button1 {
              title
              url
            }
            button2 {
              title
              url
            }
          }
        }
        homeBenefits {
          background {
            mimeType
            altText
            localFile {
              publicURL
              childCloudinaryAsset {
                gatsbyImageData
              }
            }
          }
          benefits {
            title
            text
            image {
              mimeType
              altText
              localFile {
                publicURL
                childCloudinaryAsset {
                  gatsbyImageData
                }
              }
            }
          }
        }
        homeServices {
          title
          services {
            name
            text
            image {
              mimeType
              altText
              localFile {
                publicURL
                childCloudinaryAsset {
                  gatsbyImageData
                }
              }
            }
            link {
              url
              title
              target
            }
          }
        }
        homeAbout {
          background {
            mimeType
            altText
            localFile {
              publicURL
              childCloudinaryAsset {
                gatsbyImageData
              }
            }
          }
          leftImage {
            mimeType
            altText
            localFile {
              publicURL
              childCloudinaryAsset {
                gatsbyImageData
              }
            }
          }
          rightImage {
            mimeType
            altText
            localFile {
              publicURL
              childCloudinaryAsset {
                gatsbyImageData
              }
            }
          }
          title
          text
          button {
            title
            url
          }
        }
        homeBlogs {
          title
          button {
            url
            title
          }
          posts {
            ... on WpPost {
              title
              excerpt
              uri
              date(formatString: "ll")
              nodeType
              categories {
                nodes {
                  uri
                  name
                }
              }
              featuredImage {
                node {
                  mimeType
                  altText
                  localFile {
                    publicURL
                    childCloudinaryAsset {
                      gatsbyImageData
                    }
                  }
                }
              }
            }
          }
        }
      }
      nodeType
      uri
      seo {
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        canonical
        cornerstone
        schema {
          articleType
          pageType
          raw
        }
      }
    }
    shopifyCollection(handle: {eq: "best-sellers"}) {
      id
      products {
        id
        createdAt
        priceRangeV2 {
          maxVariantPrice {
            amount
          }
          minVariantPrice {
            amount
          }
        }
        vendor
        title
        handle
        variants {
          title
          price
          availableForSale
          compareAtPrice
          legacyResourceId
          storefrontId
          selectedOptions {
            name
          }
        }
        featuredImage {
          altText
          src
        }
        shopifyId
        metafields {
          key
          namespace
          value
        }
      }
    }
  }
`